import { HomeView } from './view';

export default function Home() {
  return <HomeView />;
}
